export default "__VITE_PUBLIC_ASSET__fac7aa1c__"